import React, { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import noRecordsImg from "../assets/images/no-record-found 3.png";

function NormalTransactionHistory({ agent: propAgent }) {
    const location = useLocation();
    const navigate = useNavigate();
    
    // Get agent from props or location state
    const agent = propAgent || location.state?.agent;

    const [transactions, setTransactions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const rowsPerPage = 10;

    useEffect(() => {
        setTimeout(() => {
            if (agent) {
                console.log('Agent data for normal transactions:', agent);
                
                // Extract customer wallet transactions from the nested structure
                let customerTransactions = [];
                
                // Check for customer wallet transactions
                if (agent.customer_details?.wallet_details?.recent_transactions) {
                    customerTransactions = agent.customer_details.wallet_details.recent_transactions;
                    console.log('Found customer wallet transactions:', customerTransactions);
                } 
                // Check for direct transactions
                else if (agent.transactions) {
                    customerTransactions = agent.transactions;
                    console.log('Found direct transactions:', customerTransactions);
                }
                // Check for recent_transactions
                else if (agent.recent_transactions) {
                    customerTransactions = agent.recent_transactions;
                    console.log('Found recent transactions:', customerTransactions);
                }
                // Check for wallet_details transactions
                else if (agent.wallet_details?.recent_transactions) {
                    customerTransactions = agent.wallet_details.recent_transactions;
                    console.log('Found wallet details transactions:', customerTransactions);
                }

                setTransactions(customerTransactions);
            }
            setLoading(false);
        }, 300);
    }, [agent]);

    const formatDate = (dateString) => {
        if (!dateString) return "N/A";
        try {
            return new Date(dateString).toLocaleDateString("en-GB", {
                year: "numeric",
                month: "short",
                day: "numeric"
            });
        } catch {
            return dateString;
        }
    };

    const totalPages = Math.ceil(transactions.length / rowsPerPage);
    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentTransactions = transactions.slice(indexOfFirstRow, indexOfLastRow);

    if (!agent) return <p>No agent data available.</p>;

    return (
        <div className="transaction-container">
            <div className="transaction-header">
                <h2 className="title">Customer Wallet Transaction History</h2>
                <div className="transaction-count">
                    {transactions.length} {transactions.length === 1 ? "Transaction" : "Transactions"}
                </div>
            </div>

            <div className="transaction-content">
                {loading ? (
                    <div className="loading-container">
                        <div className="loading-spinner"></div>
                        <p>Loading transactions...</p>
                    </div>
                ) : currentTransactions.length > 0 ? (
                    <>
                        <div className="transaction-table-container">
                            <div className="table-header">
                                <div className="cell date">Date</div>
                                <div className="cell type">Type</div>
                                <div className="cell description">Description</div>
                                <div className="cell units">Amount</div>
                            </div>
                            <div className="table-body">
                                {currentTransactions.map((txn, idx) => (
                                    <div className="table-row" key={idx}>
                                        <div className="cell date" data-label="Date">{formatDate(txn.date)}</div>
                                        <div className="cell type" data-label="Type">
                                            <span className={`type-badge ${txn.transaction_type?.toLowerCase() || 'credit'}`}>
                                                {txn.transaction_type || 'Credit'}
                                            </span>
                                        </div>
                                        <div className="cell description" data-label="Description">{txn.description || 'No description'}</div>
                                        <div className={`cell units ${txn.amount < 0 ? "negative" : "positive"}`} data-label="Amount">
                                            {txn.amount < 0 ? "-" : "+"}{Math.abs(txn.amount)} Units
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </>
                ) : (
                    <div className="no-records">
                        <img src={noRecordsImg} alt="No records" />
                        <h3>No transactions yet</h3>
                        <p>Customer wallet transactions will appear here when purchases are made.</p>
                    </div>
                )}
            </div>

            {transactions.length > 0 && (
                <div className="transaction-pagination">
                    <button 
                        className="page-btn" 
                        onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
                        disabled={currentPage === 1}
                    >
                        &lt;
                    </button>
                    {Array.from({ length: totalPages }, (_, i) => (
                        <button
                            key={i}
                            className={`page-btn ${currentPage === i + 1 ? "active" : ""}`}
                            onClick={() => setCurrentPage(i + 1)}
                        >
                            {i + 1}
                        </button>
                    ))}
                    <button 
                        className="page-btn" 
                        onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))}
                        disabled={currentPage === totalPages}
                    >
                        &gt;
                    </button>
                </div>
            )}

            <div className="back-link">
                <Link to="/advertising-agent-wallet-details" state={{ agent }}>Back to Wallet &lt;&lt;</Link>
            </div>
        </div>
    )
}

export default NormalTransactionHistory